import { useCurrentUserGroups } from "@admin/hooks/useCurrentUserGroups";
import {
  mergeInstanceWithFoodControl,
  useFoodControls,
} from "@admin/hooks/useFoodControls";
import {
  CompanyLocation,
  FoodControlPointInstanceDto,
  getFoodControlPointInstancesFromLocationId,
  InstanceStatus,
} from "@enos-monorepo/lib";
import { useQuery } from "@tanstack/react-query";
import { useMemo, useState } from "react";

import { Explanation, OverDueControlsTable } from "..";
import { DeleteOverdues } from "./DeleteOverdues";

interface OverDueControlsProps {
  selectedLocation?: CompanyLocation;
}

export function OverDueControls({ selectedLocation }: OverDueControlsProps) {
  const { isSuperAdmin } = useCurrentUserGroups();

  const { controlPoints } = useFoodControls(selectedLocation);

  const { data: controlPointInstances } = useQuery({
    queryKey: ["foodControlPointInstances", selectedLocation?.id],
    queryFn: () =>
      getFoodControlPointInstancesFromLocationId(selectedLocation?.id ?? ""),
    enabled: !!selectedLocation,
  });

  const controls = useMemo(
    () =>
      mergeInstanceWithFoodControl(
        controlPoints,
        controlPointInstances?.filter((instance) => !instance.isDeleted),
      ),
    [controlPoints, controlPointInstances],
  );

  const [selectedControls, setSelectedControls] = useState<
    FoodControlPointInstanceDto[]
  >([]);

  return (
    <div className="flex gap-7.5">
      <div className="flex-1">
        <OverDueControlsTable
          expiredControls={controls.filter(
            (control) => control.status === InstanceStatus.expired,
          )}
          onRowSelection={setSelectedControls}
        />
      </div>
      <div className="flex-1 flex flex-col gap-7.5">
        <Explanation selectedInstances={selectedControls} />
        {isSuperAdmin && (
          <DeleteOverdues selectedInstances={selectedControls} />
        )}
      </div>
    </div>
  );
}
